import { RouteProps } from '../../routes/AppRouter'
import React from 'react'
import { Editor as UP } from '../../features/user-profile'
import { UserNewExtern as UEX } from 'features/users-new/extern-professional/ExternProfessional'
import style from '../layout/Main.module.css'
import { Box } from '@mui/material'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import logoCareme from '../../assets/caremePlusLogo.svg'
import { getUserContainer } from 'container/user-module'
import { ILoggedUserService } from 'modules/users/services/LoggedUserService'
import { LOGGED_USER_SERVICE_KEY } from 'modules/users'

const loggedUserService = getUserContainer().get<ILoggedUserService>(LOGGED_USER_SERVICE_KEY)

export function UserProfile(props: RouteProps) {
  const loggedUser = loggedUserService.get()
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()
  const isExtern = loggedUser?.roles.includes('medExtern') ?? false
  setTitle(title)

  return (
    <>
      {' '}
      {isExtern ? <UEX /> : <UP />}
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
